import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '短视频', to: '/category/short' },
  { label: '娱乐', to: '/category/entertainment' },
  { label: '关于我们', to: '/about' },
];

const friendLinks = [
  { label: '光影社区', href: '#' },
  { label: '影视风向标', href: '#' },
  { label: '短片工坊', href: '#' },
  { label: '娱乐观察', href: '#' },
  { label: '导演手记', href: '#' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-secondary-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl" />
              </span>
              <span className="font-heading text-xl font-extrabold text-background-50">
                涩涩<span className="text-primary-400">视频</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-300">
              涩涩视频是一个热门视频聚合平台，汇聚电影、短视频、娱乐等多种类型的优质内容，
              帮助每一位观众快速发现感兴趣的视频，享受流畅舒适的浏览与探索体验。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-secondary-400">
              温馨提示：本站内容为演示展示，视频播放相关功能仅提供封面与资料展示，搜索与筛选均为前端模拟效果。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="cursor-pointer text-sm text-secondary-300 transition-colors hover:text-primary-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">友情链接</h3>
            <ul className="mt-4 space-y-2">
              {friendLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="cursor-pointer text-sm text-secondary-300 transition-colors hover:text-primary-400"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center">
          <p>© 2026 涩涩视频 · 丰富多样的热门视频聚合平台</p>
          <p>演示用途 · 内容版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}